// Set utils function parseTime to filter
export { parseTime } from '@/utils'

// Filter for article status
export const ordersStatusFilter = (status: string) => {
  const statusMap: { [key: string]: string } = {
    waiting: 'warning',
    processing: 'primary',
    fulfilled: 'success'
  }
  return statusMap[status]
}

// Filter to uppercase the first character
export const uppercaseFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
